import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

export const MissionButton = styled(ButtonBase)`
  position: relative;
`;
export const IconWrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
`;
